<template>
  <div class="layout-body">
    <div class="layout-header-box">
      <span @click="homeIndex">
        <v-img
          :attachment-id="settings.WEBSITE_LOGO"
          :default-img="require('@/assets/img/logo.png')"
        />
      </span>
      <div>
        <a-dropdown
          :trigger="['click']"
          placement="bottomRight"
          overlay-class-name="layout-header-consult-body"
        >
          <div @click="(e) => e.preventDefault()" class="layout-header-consult">
            <span><a-icon type="message" /> 场景咨询</span>
            <a-icon type="caret-down" />
          </div>
          <a-menu slot="overlay">
            <a-menu-item>
              <div class="layout-header-consult-title">
                <span><a-icon type="heart" theme="filled" /></span>场景咨询
              </div>
            </a-menu-item>
            <a-menu-item>
              <p class="layout-header-user-btn" @click="consult('1')">
                场景寻源咨询
              </p>
            </a-menu-item>
            <a-menu-item>
              <p class="layout-header-user-btn" @click="consult('2')">
                场景辅导咨询
              </p>
            </a-menu-item>
            <a-menu-item>
              <p class="layout-header-user-btn" @click="consult('3')">
                揭榜寻源咨询
              </p>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <a-dropdown :trigger="['click']" placement="bottomRight">
          <div
            @click="(e) => e.preventDefault()"
            class="layout-header-user-info"
          >
            <span
              ><v-img
                :attachment-id="userInfo.logoId"
                :default-img="require('@/assets/img/defaultavatar.png')"
            /></span>
            <a-icon type="caret-down" />
          </div>
          <a-menu slot="overlay">
            <a-menu-item>
              <p class="layout-header-user-btn" @click="userHome">
                <img src="@/assets/img/shouye.png" /> 用户首页
              </p>
            </a-menu-item>
            <a-menu-item>
              <p class="layout-header-user-btn" @click="setUp">
                <img src="@/assets/img/zhanghao.png" /> 账号设置
              </p>
            </a-menu-item>
            <a-menu-item>
              <p class="layout-header-user-btn" @click="signOut">
                <img src="@/assets/img/tuichudenglu.png" /> 退出登录
              </p>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </div>
    <div class="layout-content-body">
      <div class="layout-nav">
        <router-link tag="a" to="/after" active-class="active" exact
          ><icon-font type="icon-shouye" /> 用户首页</router-link
        >
        <router-link tag="a" to="/after/info" active-class="active" exact
          ><icon-font type="icon-ziliao" /> 基本资料</router-link
        >
        <router-link tag="a" to="/after/myScenes" active-class="active"
          ><icon-font type="icon-changjing" /> 我的申报</router-link
        >
        <router-link tag="a" to="/after/myBangDan" active-class="active"
          ><icon-font type="icon-wodefabang" /> 我的榜单</router-link
        >
        <router-link tag="a" to="/after/myGrades" active-class="active"
          ><icon-font type="icon-chengguo" /> 我的成果</router-link
        >
        <router-link tag="a" to="/after/userActivity" active-class="active"
          ><icon-font type="icon-huodong" /> 我的活动</router-link
        >
        <router-link tag="a" to="/after/myInteract" active-class="active">
          <icon-font type="icon-hudong" /> 我的互动
          <!-- <a-badge :count="(num1 + num2)" :offset="[20, 0]" />。 -->
        </router-link>
        <router-link tag="a" to="/after/myService" active-class="active"
          ><a-icon type="robot" /> 我的服务</router-link
        >
        <!-- <router-link tag="a" to="/after/setting" active-class="active"
          ><icon-font type="icon-zhanghao" /> 账号设置</router-link
        > -->
      </div>
      <div class="layout-content">
        <router-view />
      </div>
    </div>
    <consult-form
      v-if="consultShow"
      :show="consultShow"
      :type="consultType"
      v-model="consultShow"
    />
  </div>
</template>

<script>
import iconFont from "@/components/iconFont";
import { getFeedbackList, getCommentList } from "@/api/interactive";
import { mapGetters } from "vuex";
import consultForm from "../consult/consultForm.vue";
import VImg from "@/components/VImg";
export default {
  components: {
    VImg,
    iconFont,
    consultForm,
  },
  computed: mapGetters(["settings", "userInfo"]),
  data() {
    return {
      num1: 0,
      num2: 0,
      data: {
        keywords: "",
      },
      page: {
        size: 10,
        current: 1,
      },
      consultType: "",
      consultShow: false,
    };
  },
  mounted() {
    this.loadGetFeedbackList();
    this.loadgetCommentList();
  },
  methods: {
    loadgetCommentList() {
      getCommentList(this.psge, this.data).then((res) => {
        this.num1 = res.data.total;
      });
    },
    loadGetFeedbackList() {
      getFeedbackList(this.psge, this.data).then((res) => {
        this.num2 = res.data.total;
      });
    },
    signOut() {
      let _this = this;
      this.$confirm({
        title: "确定退出登录?",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          _this.$store.dispatch("Logout");
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    },
    homeIndex() {
      this.$router.push("/");
    },
    setUp() {
      this.$router.push("/after/setting");
    },
    userHome() {
      this.$router.push("/after");
    },
    consult(type) {
      this.consultType = type;
      this.consultShow = true;
    },
  },
};
</script>

<style lang="less" scoped>
.layout-body {
  height: 100%;
  .layout-header-box {
    height: 64px;
    background: #1d1d1d;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    > span {
      cursor: pointer;
      > img {
        display: block;
      }
    }
    > div {
      display: flex;
      align-items: center;
      > span {
        color: #fff;
        margin-right: 40px;
        cursor: pointer;
      }
      .layout-header-user-info {
        display: flex;
        align-items: center;
        cursor: pointer;
        height: 64px;
        > span {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 16px;
          > img {
            display: block;
            height: 100%;
            height: 100%;
          }
        }
        > i {
          color: #fff;
        }
      }
    }
  }
  .layout-content-body {
    height: calc(100% - 64px);
    display: flex;
    .layout-nav {
      height: 100%;
      width: 240px;
      background: #f8f8f8;
      padding-top: 24px;
      > a {
        display: flex;
        height: 40px;
        padding-left: 50px;
        align-items: center;
        color: #262626;
        border-left: 4px solid transparent;
        transition: all 0.3s;
        > i {
          transition: all 0.3s;
          color: #8c8c8c;
          margin-right: 8px;
          font-size: 16px;
        }
        &:hover {
          background: #f2f2f2;
          border-color: #1abc9c;
          color: #1abc9c;
          > i {
            color: #1abc9c;
          }
        }
        &.active {
          background: #f2f2f2 !important;
          border-color: #1abc9c !important;
          color: #1abc9c !important;
          > i {
            color: #1abc9c !important;
          }
        }
      }
    }
    .layout-content {
      height: 100%;
      overflow-y: auto;
      flex: 1;
    }
  }
}
.layout-header-consult {
  display: flex;
  align-items: center;
  margin-right: 40px;
  cursor: pointer;
  height: 64px;
  color: #fff;
  > i {
    margin-left: 10px;
    font-size: 12px;
  }
  > span {
    display: flex;
    align-items: center;
    > i {
      margin-right: 6px;
    }
  }
}
.layout-header-consult-title {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 16px;
  > span {
    background: #1abc9c;
    width: 24px;
    height: 24px;
    color: #fff;
    border-radius: 6px;
    text-align: center;
    line-height: 24px;
    margin-right: 10px;
  }
}
</style>
<style lang="less" scoped>
.layout-header-user-btn {
  margin-bottom: 0;
  line-height: 30px;
  display: flex;
  align-items: center;
  > img {
    margin-right: 16px;
  }
}
</style>
<style>
.layout-header-consult-body {
  top: 64px !important;
  width: 184px;
  border-radius: 0 !important;
}
.layout-header-consult-body .ant-dropdown-menu {
  border-radius: 0 !important;
}
.layout-header-consult-body
  .ant-dropdown-menu
  .ant-dropdown-menu-item:first-child {
  padding: 16px;
  background: #1e232e;
  margin-top: -4px;
}
</style>
